<div class="container">
  <div class="bg-app-bar px-6 h-16 border-b sticky left-0 flex items-center">
    <h2 class="title my-0 ltr:pr-4 rtl:pl-4 ltr:mr-4 rtl:ml-4 ltr:border-r rtl:border-l hidden sm:block flex-none">
      <span>{{"CHALLENGE-TIME.HEADER" | translate}}</span>
    </h2>
    <button class="flex-none blue-bottone" color="primary" mat-mini-fab matTooltip="reload" type="button"
      (click)="getTimeChallenges()">
      <mat-icon svgIcon="mat:autorenew"></mat-icon>
    </button>

    <button class="ml-4 flex-none blue-bottone" color="primary" mat-mini-fab
      [matTooltip]="'WELLNESS.EDIT_MODAL.NEW' | translate" type="button" (click)="newTimeChallenge()">
      <mat-icon svgIcon="mat:add"></mat-icon>
    </button>
  </div>
  <div class="recipe-results mt-4">
    <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 mb-4">
      <div *ngFor="let item of challenges; let i = index" class="card border p-4 rounded-lg h-full "
        [ngClass]="{ 'col-span-full': expandedCardId === item._id }">
        <div class="inner-card">
          <div class="w-90" *ngIf="expandedCardId !== item._id">
            <h3 class="text-sm font-semibold mb-2">
              {{ item.i18nTitle[translate.currentLang.toUpperCase()] }}
            </h3>
            <p class="date-size">{{item.startDate}} - {{item.endDate}}</p>
            <img src="https://play.vidyard.com/{{item.i18nThumb[translate.currentLang.toUpperCase()]}}.jpg"
              class="w-full h-32 object-cover rounded-lg mb-4" />

            <div *ngIf="expandedCardId === item._id" class="mb-4">
              <div [innerHTML]="item.i18nDescription[translate.currentLang.toUpperCase()]"></div>
            </div>
          </div>
          <div class="w-90" *ngIf="expandedCardId === item._id">
            <div class="form-row">
              <mat-form-field appearance="fill">
                <mat-label>{{"CHALLENGE-TIME.TITLE" | translate}} {{"GLOBAL.ITA" | translate}}</mat-label>
                <input matInput [(ngModel)]="item.i18nTitle['IT']" required>
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>{{"CHALLENGE-TIME.TITLE" | translate}} {{"GLOBAL.ENG" | translate}}</mat-label>
                <input matInput [(ngModel)]="item.i18nTitle['EN']" required>
              </mat-form-field>
            </div>
            <div class="form-row">
              <mat-form-field appearance="fill">
                <mat-label>{{"CHALLENGE-TIME.PUBLISH" | translate}}</mat-label>
                <input matInput [matDatepicker]="pickerPubblicazione" [(ngModel)]="item.startDate" required>
                <mat-datepicker-toggle matSuffix [for]="pickerPubblicazione"></mat-datepicker-toggle>
                <mat-datepicker #pickerPubblicazione></mat-datepicker>
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>{{"CHALLENGE-TIME.EXPIRE" | translate}}</mat-label>
                <input matInput [matDatepicker]="pickerScadenza" [(ngModel)]="item.endDate" required>
                <mat-datepicker-toggle matSuffix [for]="pickerScadenza"></mat-datepicker-toggle>
                <mat-datepicker #pickerScadenza></mat-datepicker>
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>{{"CHALLENGE-TIME.ACCEPTANCE" | translate}}</mat-label>
                <input matInput type="number" [(ngModel)]="item.acceptancePeriod" required>
              </mat-form-field>
              <div class="d-flex-draft">
                <mat-label>{{"CHALLENGE-TIME.DRAFT" | translate}}</mat-label>
                <mat-slide-toggle [(ngModel)]="item.draft">
                </mat-slide-toggle>
              </div>
            </div>
            <div class="form-row">
              <mat-form-field appearance="fill">
                <mat-label>Img URL {{"GLOBAL.ITA" | translate}}</mat-label>
                <input matInput [(ngModel)]="item.i18nThumb['IT']" required>
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>Img URL {{"GLOBAL.ENG" | translate}}</mat-label>
                <input matInput [(ngModel)]="item.i18nThumb['EN']" required>
              </mat-form-field>
            </div>
            <div class="form-row">
              <mat-form-field appearance="fill">
                <mat-label>{{"CHALLENGE-TIME.DESC" | translate}} {{"GLOBAL.ITA" | translate}}</mat-label>
                <textarea cols="30" rows="4" matInput [(ngModel)]="item.i18nDescription['IT']" required></textarea>
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>{{"CHALLENGE-TIME.DESC" | translate}} {{"GLOBAL.ENG" | translate}}</mat-label>
                <textarea cols="30" rows="4" matInput [(ngModel)]="item.i18nDescription['EN']" required></textarea>
              </mat-form-field>
            </div>
          </div>
          <div class="controls-card">
            <mat-icon svgIcon="mat:delete" class="delete-icon" (click)="deleteChallenge(item._id)"></mat-icon>
            <mat-icon svgIcon="mat:edit" *ngIf="expandedCardId !== item._id"
              (click)="expandedCardId = item._id"></mat-icon>
            <mat-icon svgIcon="mat:save" *ngIf="expandedCardId === item._id" (click)="updateTimeChallenge(item)"></mat-icon>
            <mat-icon svgIcon="mat:zoom_in_map" *ngIf="expandedCardId === item._id"
              (click)="expandedCardId = null"></mat-icon>
            <mat-icon svgIcon="mat:add_circle" (click)="createSubTimeChallenge(item)"></mat-icon>
            <mat-icon svgIcon="mat:hourglass_empty" *ngIf="item.draft"></mat-icon>
            <mat-icon svgIcon="mat:download" *ngIf="!item.draft" (click)="customExcelDownload(item)"></mat-icon>
          </div>
        </div>
        <span *ngIf="expandedCardId === item._id">
          <div class="card" *ngFor="let chall of item.challenges; let k = index;">
            <div class="card-sub-title">
              <p>{{ chall.i18nTitle[translate.currentLang.toUpperCase()] }}</p>
              <span>
                <mat-icon svgIcon="mat:add_circle" (click)="newWeekTimeChallenge(chall, item._id, k)"></mat-icon>
                <mat-icon svgIcon="mat:edit" (click)="editSubTimeChallenge(item, k)"></mat-icon>
                <mat-icon svgIcon="mat:delete" class="delete-icon" (click)="deleteSubChallenge(k, item._id)"></mat-icon>
              </span>
            </div>
            <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 mb-4 p-2">
              <div class="card week-card" *ngFor="let week of chall.weeks; let f = index">
                <span>
                  <p>{{'week'+ ' ' + f}}</p>
                  <p>{{"CHALLENGE-TIME.PUBLISH" | translate}}: {{week.publishDate}}</p>
                </span>
                <span>
                  <mat-icon svgIcon="mat:edit" (click)="editWeekTimeChallenge(item, k, f)"></mat-icon>
                  <mat-icon svgIcon="mat:delete" class="delete-icon" (click)="deleteWeekTimeChallenge(item._id, k, f)"></mat-icon>
                </span>
              </div>
            </div>
          </div>
        </span>
      </div>
    </div>

    <mat-paginator *ngIf="challenges" [length]="lunghezza" [pageSize]="pageSize" (page)="onPageChanged($event)">
    </mat-paginator>
  </div>
</div>
